const AssetAllocationsTable = require('okCharts/AssetAllocationsTable');

module.exports = AssetAllocationsTable;